<template>
  <div class="aegent">
    <h1>Modulo Aegent</h1>
    <p>Questo è il modulo principale di Aegent per la gestione delle funzionalità avanzate.</p>
    
    <div class="row mt-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5><i class="fa fa-file-pdf-o me-2"></i>Gestione PDF</h5>
          </div>
          <div class="card-body">
            <p>Genera e gestisci documenti PDF personalizzati.</p>
            <a :href="pdfUrl" target="_blank" class="btn btn-primary">
              <i class="fa fa-download me-2"></i>Scarica PDF di Test
            </a>
          </div>
        </div>
      </div>
      
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5><i class="fa fa-database me-2"></i>Database Info</h5>
          </div>
          <div class="card-body">
            <button @click="fetchDbInfo" class="btn btn-outline-info">
              Controlla Database
            </button>
            
            <div v-if="dbInfo" class="mt-3">
              <pre class="bg-light p-2 rounded"><code>{{ dbInfo }}</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5><i class="fa fa-cogs me-2"></i>Azioni Rapide</h5>
          </div>
          <div class="card-body">
            <div class="d-flex gap-2 flex-wrap">
              <button class="btn btn-success" @click="showSuccess">
                <i class="fa fa-check me-1"></i>Test Success
              </button>
              <button class="btn btn-warning" @click="showWarning">
                <i class="fa fa-warning me-1"></i>Test Warning
              </button>
              <button class="btn btn-info" @click="refreshData">
                <i class="fa fa-refresh me-1"></i>Refresh Data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useAppStore } from '../stores/app.js'

export default {
  name: 'Aegent',
  setup() {
    const appStore = useAppStore()
    const dbInfo = ref(null)
    
    const pdfUrl = computed(() => `${appStore.apiUrl}/aegent_test/testae/pdf`)
    
    const fetchDbInfo = async () => {
      appStore.setLoading(true)
      try {
        const response = await fetch('/api/v1/health')
        const data = await response.json()
        dbInfo.value = JSON.stringify(data, null, 2)
      } catch (error) {
        dbInfo.value = 'Errore nella connessione: ' + error.message
      } finally {
        appStore.setLoading(false)
      }
    }
    
    const showSuccess = () => {
      alert('✅ Operazione completata con successo!')
    }
    
    const showWarning = () => {
      alert('⚠️ Attenzione: questa è solo una demo!')
    }
    
    const refreshData = () => {
      dbInfo.value = null
      fetchDbInfo()
    }
    
    return {
      dbInfo,
      pdfUrl,
      fetchDbInfo,
      showSuccess,
      showWarning,
      refreshData
    }
  }
}
</script>